import { TaskBoardPage } from '@pages/TaskBoard';

export const TasksPage = () => (
    <div className="smetter-css task-css flex min-h-0 flex-1 flex-col">
        <TaskBoardPage fillAvailableHeight portalFileOverlays />
    </div>
);
